import './recipe-list.scss';

class RecipeList {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-recipelist',
            headlineAttr: 'headline'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$recipeList = $element;
        this.$recipeListHeadline = this.$recipeList.querySelector('[' + this.settings.initAttr + '="' + this.settings.headlineAttr + '"]');

        this.resizeHandler = window.resizeHandler;
        this.resizeTimeout = null;

        this.initialize();
    }

    initialize () {
        if (this.$recipeListHeadline) {
            this.checkSize();
            this.resizeHandler.customFunctions.push(() => {
                this.checkSize();
            });
        }
    }

    checkSize () {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(() => {
            this.calculateHeadline();
        }, 100);
    }

    calculateHeadline () {
        const headlineAPI = this.$recipeListHeadline.API;
        const headlineElement = headlineAPI.fittyElement;
        const compStyles = window.getComputedStyle(headlineElement);
        const fontSize = parseInt(compStyles.getPropertyValue('font-size'));

        this.$recipeList.style.paddingTop = fontSize * 0.25 + 'px';
        this.$recipeList.style.minHeight = this.$recipeListHeadline.offsetHeight + 'px';
    }
}

export { RecipeList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$recipeList = $context.querySelectorAll('[data-recipeList="root"]');
        for (let i = 0; i < $$recipeList.length; i++) {
            const $recipeList = $$recipeList[i];

            const recipeListAPI = new RecipeList($recipeList);
            $recipeList.API = recipeListAPI;
        }
    }
});
